import { Translate } from 'react-redux-i18n'
import TooltipExpression from '../../common/tooltipExpression'

export const CHARTS = [
  {
    title: 'financialAnalysis.NIM',
    dataKey: 'FA150',
    color: '#006AA6',
    tooltipContent: (
      <div>
        <TooltipExpression
          expressions={[
            {
              text: <Translate value="financialAnalysis.NIM_1" />,
              operator: '=',
            },
            {
              text: <Translate value="financialAnalysis.NIM_2" />,
              isDivide: true,
              textUnder: <Translate value="financialAnalysis.NIM_3" />,
            },
          ]}
        />
        <div className="fw600 mt2 mb2">
          <Translate value="financialAnalysis.IN_WHICH" />
        </div>
        <TooltipExpression
          style={{ alignItems: 'unset' }}
          expressions={[
            {
              text: <Translate value="financialAnalysis.NIM_4" />,
              operator: '=',
              styleContainer: { alignItems: 'unset' },
            },
            {
              text: (
                <>
                  <Translate value="financialAnalysis.NIM_5" />
                  <br />
                  +&nbsp;
                  <Translate value="financialAnalysis.NIM_6" />
                  <br />
                  +&nbsp;
                  <Translate value="financialAnalysis.NIM_7" />
                  <br />
                  +&nbsp;
                  <Translate value="financialAnalysis.NIM_8" />
                  <br />
                  +&nbsp;
                  <Translate value="financialAnalysis.NIM_9" />
                  <br />
                  +&nbsp;
                  <Translate value="financialAnalysis.NIM_10" />
                  <br />
                  +&nbsp;
                  <Translate value="financialAnalysis.NIM_11" />
                  <br />
                  -&nbsp;
                  <Translate value="financialAnalysis.NIM_12" />
                </>
              ),
              styleText: { textAlign: 'unset' },
              styleContainer: { alignItems: 'unset' },
            },
          ]}
        />
      </div>
    ),
  },
  {
    title: 'financialAnalysis.CIR',
    dataKey: 'RT0252',
    color: '#FFCD60',
    tooltipContent: (
      <TooltipExpression
        expressions={[
          {
            text: <Translate value="financialAnalysis.CIR_1" />,
            operator: '=',
          },
          {
            text: <Translate value="financialAnalysis.CIR_2" />,
            isDivide: true,
            textUnder: <Translate value="financialAnalysis.CIR_3" />,
          },
        ]}
      />
    ),
  },
  { title: 'ROA', dataKey: 'RT0059', color: '#00A8B5' },
  { title: 'ROE', dataKey: 'RT0060', color: '#FF596A' },
]
